// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3PO1g","left":"InfoRow_left__krRLO"};